export default __webpack_public_path__ + "static/media/jr_headshot.cbc20f3a.png";